import { createSlice } from '@reduxjs/toolkit'
import { PROPERTY_NAME } from 'Constants/Properties'

export const initialState = {
    list: [],
    listLoading: false,
    listError: null,
    createError: null,
    createLoading: false,
    loading: false,
    error: null,
    business: {},
    isOpen: false,
    adminMode: false
}

const businessSlice = createSlice({
    name: 'business',
    initialState,
    reducers: {
        loadBusinessesRequest(state) {
            state.listLoading = true
            state.listError = null
        },
        loadBusinessesSuccess(state, action) {
            state.listLoading = false
            state.list = action.payload.list
        },
        loadSuccess(state, action) {
            state.listLoading = false
            state.list = action.payload
            state.listError = null
        },
        createBusinessRequest(state) {
            state.createLoading = true
            state.createError = null
        },
        createBusinessSuccess(state) {
            state.createLoading = false
        },
        createBusinessFailure(state, action) {
            state.createLoading = false
            state.createError = action.payload.error
        },
        loadOneBusinessRequest(state) {
            state.loading = true
            state.error = null
        },
        loadOneBusinessSuccess(state, action) {
            let templatePath = action.payload.business.templatePath
            if (
                state.business &&
                state.business.objectId === action.payload.business.objectId &&
                !action.payload.business.templatePath
            ) {
                templatePath = state.business.templatePath
            }
            state.loading = false
            state.business = { ...action.payload.business, templatePath }
        },
        loadOneBusinessFailure(state, action) {
            state.loading = false
            state.error = action.payload.error
            state.business = {}
        },
        createBusinessProperty(state, action) {
            if (state.business.objectId !== action.payload.businessId) return
            const next = state.business.properties ? state.business.properties.slice() : []
            next.push(action.payload.property)
            state.business = { ...state.business, properties: next }
        },
        updateBusinessProperty(state, action) {
            const property = action.payload.property
            const hasProps = Array.isArray(state.business.properties)
            const props = hasProps
                ? state.business.properties.map(p => (p.objectId === property.objectId ? property : p))
                : state.business.properties
            state.business = {
                ...state.business,
                properties: props,
                name: property.name === PROPERTY_NAME ? property.value : state.business.name
            }
        },
        menuCollapse(state, action) {
            state.isOpen = action.payload.close
        },
        toggleAdminMode(state) {
            state.adminMode = !state.adminMode
        },
        setAdminMode(state, action) {
            state.adminMode = action.payload.adminMode
        }
    }
})

export const businessActions = businessSlice.actions
export default businessSlice.reducer

// Re-export legacy thunks for compatibility until they are migrated
// Removed circular re-exports

// Convenience wrappers to match legacy Actions API
export const setIsOpen = (close) => (dispatch) => dispatch(businessActions.menuCollapse({ close }))
export const toggleAdminMode = () => (dispatch) => dispatch(businessActions.toggleAdminMode())
export const setAdminMode = (adminMode) => (dispatch) => dispatch(businessActions.setAdminMode({ adminMode }))

// Upload logo placeholder (if used by Logo.js)
export const uploadLogo = (businessId, name, file) => () => {
    console.warn('uploadLogo not implemented in ModernAPI');
    return Promise.resolve({ success: false })
}

// Add missing exports that components are trying to import
export const create = () => () => Promise.reject(new Error('Not implemented'))
export const load = () => (dispatch) => {
    // Return empty array for now to prevent errors
    dispatch({ type: 'business/loadSuccess', payload: [] })
    return Promise.resolve([])
}
export const loadOne = () => () => Promise.reject(new Error('Not implemented'))
export const createProperty = () => () => Promise.reject(new Error('Not implemented'))
export const editProperty = () => () => Promise.reject(new Error('Not implemented'))
export const initPropertyVerification = () => () => Promise.reject(new Error('Not implemented'))
export const verifyProperty = () => () => Promise.reject(new Error('Not implemented'))

